var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePinCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.479 23.289V34.666H36.765V23.3959C36.765 19.6788 33.7671 16.6683 30.0716 16.6683C26.3701 16.6683 23.3782 19.6847 23.3782 23.39V34.6601H20.5992V23.289C20.5874 18.0459 24.8151 13.8003 30.0361 13.8003C35.2572 13.8003 39.479 18.0459 39.479 23.289Z",
    fill: "#DBDEDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.401 23.289V34.666H36.687V23.3959C36.687 19.6966 33.7128 16.692 30.041 16.6742V13.8003C35.2206 13.8478 39.401 18.0756 39.401 23.289Z",
    fill: "#B9CED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.828 24.8684L37.8634 34.6719H36.6927V23.4018C36.6927 19.6847 33.7008 16.6801 30.0052 16.6801C26.3097 16.6801 23.3178 19.8509 23.3178 23.568V34.6719H22.0524L22.017 24.7437C21.9105 18.7583 25.7361 15.5816 30.0348 15.5816C34.3275 15.5697 38.1768 18.604 37.828 24.8684Z",
    fill: "#A0B9C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7344 34.666V23.396C36.7344 19.6788 33.7425 16.6743 30.0469 16.6743H30.0351V15.5698C30.0469 15.5698 30.0647 15.5698 30.0706 15.5698C34.3574 15.5698 38.2126 18.5922 37.8578 24.8626L37.8933 34.666H36.7225H36.7344Z",
    fill: "#87ACB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6266 45.4048H21.4024C19.8651 45.4048 18.6234 44.1519 18.6234 42.614V27.698C18.6234 26.1542 19.871 24.9072 21.4024 24.9072H38.6207C40.158 24.9072 41.3997 26.1601 41.3997 27.698V42.608C41.4056 44.1638 40.1639 45.4048 38.6266 45.4048Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3822 27.6805V29.0878C41.3822 27.544 40.1346 26.297 38.6032 26.297H21.379C19.8416 26.297 18.5999 27.5499 18.5999 29.0878V27.6746C18.5999 26.1307 19.8476 24.8838 21.379 24.8838H38.5972C40.1346 24.8897 41.3822 26.1426 41.3822 27.6805Z",
    fill: "#E3E6E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3822 42.5908V44.004C41.3822 45.5479 40.1346 46.7948 38.6032 46.7948H21.379C19.8416 46.7948 18.5999 45.5419 18.5999 44.004V42.5908C18.5999 44.1347 19.8476 45.3816 21.379 45.3816H38.5972C40.1346 45.3876 41.3822 44.1347 41.3822 42.5908Z",
    fill: "#AEB5BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.23 35.9041L31.7681 38.3209C31.8154 38.5406 31.6439 38.7543 31.4251 38.7543H28.6224C28.3918 38.7543 28.2204 38.5406 28.2795 38.3209L28.8176 35.8626C28.2204 35.4291 27.8656 34.6987 27.9661 33.8971C28.0784 32.9352 28.8589 32.1514 29.8168 32.0505C31.094 31.9079 32.1642 32.9055 32.1642 34.1525C32.1524 34.8828 31.7858 35.53 31.23 35.9041Z",
    fill: "#42342F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7678 38.3324C31.8151 38.5521 31.6436 38.7659 31.4248 38.7659H30.0117V32.0442C31.1942 32.0264 32.1521 32.9764 32.1521 34.164C32.1521 34.8884 31.7855 35.5297 31.2297 35.9098L31.7678 38.3324Z",
    fill: "#2F241F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6266 35.4993C43.7046 36.6572 42.5591 37.6044 41.2613 38.2832C39.9636 37.6044 38.8174 36.6572 37.8971 35.4993C36.4271 33.5629 36.607 30.8973 36.607 30.8714V27.5586C39.6589 26.8138 42.838 26.8138 45.889 27.5586V30.8714C45.9042 30.8983 46.0793 33.5847 44.6266 35.4993Z",
    fill: "#4AC600"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1142 29.7539L40.693 33.3017L39.0552 31.6223L38.4141 32.2705L40.3715 34.278C40.4546 34.3631 40.5681 34.4093 40.6871 34.4093H40.6886C40.8086 34.4093 40.9246 34.3589 41.0057 34.2738L44.7498 30.3995L44.1142 29.7539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePinCode);
export default __webpack_public_path__ + "static/media/ActivePinCode.6692068cf6b83b870329ece7f12f7486.svg";
export { ForwardRef as ReactComponent };